/* eslint-disable @typescript-eslint/no-explicit-any */
export default function ToastContainer({ toasts, dismiss }:any) {
  return (
    <div className="fixed top-5 right-5 space-y-2 z-50">
      {toasts.map((toast:any) => (
        <div
          key={toast.id}
          className={`p-4 rounded shadow text-white ${
            toast.variant === "destructive"
              ? "bg-red-500"
              : "bg-gray-800"
          }`}
        >
          <div className="font-bold">{toast.title}</div>
          <div>{toast.description}</div>

          <button
            className="text-xs mt-2 underline"
            onClick={() => dismiss(toast.id)}
          >
            Close
          </button>
        </div>
      ))}
    </div>
  );
}